import {
  BUSINESS_ACTIVITY_KIND,
  INVOICE_DATA_FIELDS,
  visibleFieldsForKind
} from "../invoiceFields";

const FE_TO_API = {
  [INVOICE_DATA_FIELDS.FIRST_NAME]: "first_name",
  [INVOICE_DATA_FIELDS.LAST_NAME]: "last_name",
  [INVOICE_DATA_FIELDS.NIP]: "nip",
  [INVOICE_DATA_FIELDS.COMPANY_NAME]: "company_name",
  [INVOICE_DATA_FIELDS.STREET]: "street",
  [INVOICE_DATA_FIELDS.STREET_NUMBER]: "street_number",
  [INVOICE_DATA_FIELDS.FLAT_NUMBER]: "flat_number",
  [INVOICE_DATA_FIELDS.CITY]: "city",
  [INVOICE_DATA_FIELDS.POSTAL_CODE]: "postal_code",
  [INVOICE_DATA_FIELDS.COUNTRY]: "country"
};

const FORCED_NULL_FE_FIELDS_BY_KIND = {
  [BUSINESS_ACTIVITY_KIND.PRIVATE_PERSON]: [
    INVOICE_DATA_FIELDS.NIP,
    INVOICE_DATA_FIELDS.COMPANY_NAME
  ],
  [BUSINESS_ACTIVITY_KIND.OTHER_BUSINESS]: [
    INVOICE_DATA_FIELDS.FIRST_NAME,
    INVOICE_DATA_FIELDS.LAST_NAME
  ],
  [BUSINESS_ACTIVITY_KIND.SELF_EMPLOYED]: []
};

export function apiInvoiceDataToFeSlice(apiData) {
  if (!apiData || typeof apiData !== "object") return null;
  return {
    [INVOICE_DATA_FIELDS.FIRST_NAME]: apiData.first_name ?? null,
    [INVOICE_DATA_FIELDS.LAST_NAME]: apiData.last_name ?? null,
    [INVOICE_DATA_FIELDS.NIP]: apiData.nip ?? null,
    [INVOICE_DATA_FIELDS.COMPANY_NAME]: apiData.company_name ?? null,
    [INVOICE_DATA_FIELDS.STREET]: apiData.street ?? null,
    [INVOICE_DATA_FIELDS.STREET_NUMBER]: apiData.street_number ?? null,
    [INVOICE_DATA_FIELDS.FLAT_NUMBER]: apiData.flat_number ?? null,
    [INVOICE_DATA_FIELDS.CITY]: apiData.city ?? null,
    [INVOICE_DATA_FIELDS.POSTAL_CODE]: apiData.postal_code ?? null,
    [INVOICE_DATA_FIELDS.COUNTRY]: apiData.country ?? null
  };
}

export function apiInvoiceDataToSavedSlices(apiData) {
  const empty = {
    businessActivityKind: null,
    savedPrivatePersonData: null,
    savedOtherBusinessData: null,
    savedSelfEmployedData: null,
    savedInvoicesEnabled: Boolean(apiData?.invoices_enabled)
  };
  if (!apiData?.business_activity_kind) return empty;
  const kind = apiData.business_activity_kind;
  const slice = apiInvoiceDataToFeSlice(apiData);
  return {
    ...empty,
    businessActivityKind: kind,
    ...(kind === BUSINESS_ACTIVITY_KIND.PRIVATE_PERSON && {
      savedPrivatePersonData: slice
    }),
    ...(kind === BUSINESS_ACTIVITY_KIND.OTHER_BUSINESS && {
      savedOtherBusinessData: slice
    }),
    ...(kind === BUSINESS_ACTIVITY_KIND.SELF_EMPLOYED && {
      savedSelfEmployedData: slice
    })
  };
}

export function formSliceToApiInvoiceData({
  businessActivityKind,
  formSlice,
  invoicesEnabled
}) {
  const body = {
    business_activity_kind: businessActivityKind,
    invoices_enabled: invoicesEnabled !== false
  };
  const fields = visibleFieldsForKind(businessActivityKind);
  const forcedNullFields =
    FORCED_NULL_FE_FIELDS_BY_KIND[businessActivityKind] ?? [];

  for (const feKey of fields) {
    const apiKey = FE_TO_API[feKey];
    const value = formSlice?.[feKey];
    body[apiKey] = value ?? "";
  }

  for (const feKey of forcedNullFields) {
    const apiKey = FE_TO_API[feKey];
    if (apiKey) {
      body[apiKey] = "";
    }
  }

  return body;
}
